import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    meta: {
      noBack: true, //无返回按钮
      title: "route.hangqing.title",
    },
    component: () => import("@/views/MarketCondition/IndexView.vue"),
  },
  {
    path: "/contract",
    name: "contract",
    meta: {
      noBack: true, //无返回按钮
      title: "route.contract.title",
    },
    component: () => import("@/views/Contract/IndexView.vue"),
  },
  {
    path: "/options",
    name: "Options",
    meta: {
      // noBack: true, //无返回按钮
      title: "route.options.title",
    },
    component: () => import("@/views/OptionsTrade/IndexView.vue"),
  },
  {
    path: "/transaction",
    name: "transaction",
    meta: {
      noBack: true, //无返回按钮
      title: "route.transaction.title",
    },
    component: () => import("@/views/Transaction/IndexView.vue"),
  },
  {
    path: "/me",
    name: "me",
    meta: {
      noBack: true, //无返回按钮
      title: "route.me.title",
    },
    component: () => import("@/views/Me/IndexView.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: {
      noBack: true, //无返回按钮
      title: "route.about.title",
    },
    component: () => import("@/views/About/IndexView.vue"),
  },
  {
    path: "/recharge/rechargeList",
    name: "rechargeList",
    meta: {
      title: "route.recharge.title",
    },
    component: () => import("@/views/Recharge/RechargeList.vue"),
  },
  {
    path: "/withdraw",
    name: "withdraw",
    meta: {
      title: "route.withdraw.title",
    },
    component: () => import("@/views/Withdraw/IndexView.vue"),
  },
  {
    path: "/transfer",
    name: "transfer",
    meta: {
      title: "route.transfer.title",
    },
    component: () => import("@/views/Transfer/IndexView.vue"),
  },
  {
    path: "/kline/index",
    name: "kline",
    meta: {
      title: "route.kline.title",
    },
    component: () => import("@/views/KLine/IndexView.vue"),
  },
  {
    path: "/record/transactionList",
    name: "transactionList",
    meta: {
      title: "route.transaction_record.title",
    },
    component: () => import("@/views/Record/TransactionListView.vue"),
  },
  {
    path: "/record/leverList",
    name: "leverList",
    meta: {
      title: "route.lever_record.title",
    },
    component: () => import("@/views/Record/LeverListView.vue"),
  },
  {
    path: "/me/MyAssets",
    name: "MeAssets",
    meta: {
      title: "route.myassets.title",
    },
    component: () => import("@/views/MeAssets/IndexView.vue"),
  },
  {
    path: "/me/FundFlowingWater",
    name: "FundFlowingWater",
    meta: {
      title: "route.fund_flowing_water.title",
    },
    component: () => import("@/views/FundFlowingWater/IndexView.vue"),
  },
  {
    path: "/me/kyc",
    name: "KYC",
    meta: {
      title: "route.kyc.title",
    },
    component: () => import("@/views/KYC/IndexView.vue"),
  },
  {
    path: "/loans",
    name: "Loans",
    meta: {
      title: "route.loans.title"
    },
    component: () => import("@/views/Loans/IndexView.vue")
  },
  {
    path: "/loans-description",
    name: "LoansDescription",
    meta: {
      title: "Directions"
    },
    component: () => import("@/views/Loans/DescriptionView.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
